import { render, staticRenderFns } from "./mail-reply-buyer-content.vue?vue&type=template&id=579c0a62&scoped=true&"
import script from "./mail-reply-buyer-content.vue?vue&type=script&lang=js&"
export * from "./mail-reply-buyer-content.vue?vue&type=script&lang=js&"
import style0 from "./mail-reply-buyer-content.vue?vue&type=style&index=0&id=579c0a62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579c0a62",
  null
  
)

export default component.exports